import React from 'react';
import CssHelper from 'Services/Utils/Css/CssHelper';
import styles from './Container.module.sass';

const Container = ({
    children,
    padding, size
}: Props) => {
    return <div
        className={CssHelper.createCssClass(`
            ${styles['container']}
            ${styles['container__padding--'+(padding||'none')]}
            ${styles['container__size--'+(size||'full')]}
        `)}>
        { children }
    </div>;
}

interface Props {
    children?: any
    size?: 'medium' | 'full'
    padding?: 'vertical' | 'none'
}

export default Container;